import {GlobalConstants} from '../global-constants';

export function getJwtPayload<T = Record<string, unknown>>(token: string): T | null {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) {
      return null;
    }

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload) as T;
  } catch {
    console.error('Failed to decode JWT token.');
    return null;
  }
}

export function getStoredJwtPayload<T = Record<string, unknown>>(): T | null {
  const token = localStorage.getItem(GlobalConstants.TOKEN);
  if (!token) {
    return null;
  }
  return getJwtPayload<T>(token);
}


